var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08737 10.3704H4.91263V6.22235L2.82526 8.29638V11.4074C2.82526 11.9809 3.29283 12.4444 3.86894 12.4444H10.1311C10.7072 12.4444 11.1747 11.9809 11.1747 11.4074V8.29638L9.08737 6.22235V10.3704Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5242 7.99357L7 2.50465L1.47577 7.99357L0 6.5262L6.26211 0.304105C6.6702 -0.101368 7.3298 -0.101368 7.73789 0.304105L14 6.5262L12.5242 7.99357Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMover);
export default __webpack_public_path__ + "static/media/mover.05cc83c5e4b131233bbac1d41b965ee6.svg";
export { ForwardRef as ReactComponent };